import {
  BlotterTable,
  BlotterTableFilters,
  LookbackOption,
  NOTIFICATION_ALL,
  removeEmptyFilters,
  useAccordionFilterBuilder,
  usePersistedBlotterTable,
  useWsBlotterTable,
  type WebsocketRequest,
} from '@talos/kyoko';
import { useMemo } from 'react';
import type { AppNotification } from '../../../providers/AppNotifications/AppNotificationsMonitorContainer';
import { type NotificationWithToastInfo, useEnrichNotificationsPipe } from './useEnrichNotificationsPipe';
import { useNotificationsColumns } from './useNotificationsColumns';
import { onlyServerFilterKeys, useNotificationsFilter } from './useNotificationsFilter';
import { useNotificationsMenu } from './useNotificationsMenu';

export function NotificationsBlotterTable() {
  const columns = useNotificationsColumns();

  const persistedBlotterTable = usePersistedBlotterTable('notifications', {
    filter: {
      _start: LookbackOption.Past24Hours,
    },
  });

  const enrichNotificationsPipe = useEnrichNotificationsPipe();

  const filterResults = useNotificationsFilter({ persistedBlotterTable });
  const { clientSideFilter: clientLocalFilter, blotterTableFilterProps, filterBuilderProps, filter } = filterResults;

  const filterBuilderAccordion = useAccordionFilterBuilder({
    accordionProps: { initialOpen: false },
    filterBuilderProps,
  });

  const notificationsMenu = useNotificationsMenu();

  const request = useMemo(
    () => ({
      tag: 'monitoring-notifications',
      name: NOTIFICATION_ALL,
      sort_by: '-Timestamp',
      ...removeEmptyFilters(onlyServerFilterKeys(filter)),
    }),
    [filter]
  );

  const blotterTable = useWsBlotterTable<WebsocketRequest, NotificationWithToastInfo, AppNotification>({
    request,
    columns,
    rowID: 'rowID',
    clientLocalFilter,
    pipe: enrichNotificationsPipe,
    persistence: persistedBlotterTable,
    gridOptions: {
      getContextMenuItems: notificationsMenu.getContextMenuItems,
    },
  });

  return (
    <>
      <BlotterTableFilters
        {...filterBuilderAccordion}
        {...blotterTableFilterProps}
        {...blotterTable.blotterTableFiltersProps}
      />
      <BlotterTable {...blotterTable} />
      {notificationsMenu.dialogs}
    </>
  );
}
